export const UserService = {
  PRODUCT: { id: 4, name: 'service-product' },
  CORE: { id: 53, name: 'service-core' },
  MEDIA: { id: 56, name: 'service-media' },
  ETL: { id: 62, name: 'service-etl' },
  TRANSACTION: { id: 66, name: 'service-transaction' },
  SALMON: { id: 2784, name: 'Team Alkemics' },
};
